import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  actionComponentContainer: {
    minHeight: "350px",
    width: theme.width.full,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.palette.white.main,
    borderRadius: theme.borders.borderRadius.xl,
    boxShadow: theme.boxShadows.modal,
    padding: `${theme.spacing.spacing22} ${theme.spacing.spacing11}`,
  },
  actionBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  image: {
    marginBottom: theme.spacing.spacing12_5,
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.md,
  },
  buttonsSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: theme.width.full,
  },
  text: {
    marginTop: 11,
  },
  invalidTestText: {
    marginTop: theme.spacing.spacing8,
    marginBottom: theme.spacing.spacing8,
    fontSize: theme.typography.size.xs,
    color: theme.palette.primary.main,
    textAlign: "center",
  },
  twoButtons: {
    justifyContent: "space-between",
    marginTop: theme.spacing.spacing10,
  },
  invalidTestButtons: {
    flexDirection: "column",
  },
  reportIssueLink: {
    marginTop: theme.spacing.spacing8,
    color: theme.palette.primary.main,
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: theme.typography.size.md,
    textAlign: "center",
    width: theme.width.full,
  },
});
